import React, {useState, useEffect, useRef} from "react";
import PropTypes from "prop-types";
import media from "styled-media-query";
import breakpoints from "Helpers/BreakpointHelper";
import {
  RTEWrapper,
  SplitPageWrapper,
  PageColumn,
} from "BaseComponents/Wrappers";
import MapBlocksToComponents from "Helpers/BlockHelper";
import { Paragraph, Ingress, H1, Bold } from "BaseComponents/Text/";
import SideMenu from "Components/Sidemenu/SideMenu";
import {StandardImage} from "Components/StandardImage";
import { PageContainer } from "BaseComponents/Wrappers";
import styled, { css } from "styled-components";
import { PageTransition } from "Animations";
import { EmployeeListBlock, ArticleBlock } from "Blocks";
import { Video } from "Components/Video/Video";
import { getResponsiveImage } from "Helpers/ImageHelper";
import { ContentWrapper } from "Blocks/TextBlock/TextContentWrapper";
import {SocialShare as SocialShareBlock} from "Components/SocialShare";

let StandardPage = ({
  Heading,
  UseFontMarydale,
  Preamble,
  ResponsiveImages,
  Text,
  menu,
  ImageText,
  Breadcrumbs,
  LastUpdatedText,
  Contacts,
  LastUpdated,
  ShowHero,
  CenterContent,
  ElementArea,
  VideoType,
  VideoLink,
  AlignContentLeft,
  NarrowText,
  ShowSocialIcons,
  SocialShare,
  Alias,
  RalatedLinks,
  ShowRelatedLinks,
  RelatedTitileLink,
  RelatedTitle,
}) => {
  let Image = getResponsiveImage(ResponsiveImages);

  let hasChildren = menu.MenuItems.Children.length > 0;
  const [_, setWindowWidth] = useState(window.innerWidth);
  const [videoContainerHeight, setVideoContainerHeight] = useState('346px');
  const videoContainerRef = useRef(null);

  const resizeIframe = (width) => {
    const iframeElement = document.getElementById("formIframe");
    if (iframeElement) {
      switch (true) {
        case width <= 414:
          iframeElement.style.height = "2715px";
          break;
        case width <= 768:
          iframeElement.style.height = "2000px";
          break;
        default:
          iframeElement.style.height = `${
            parseInt(iframeElement.getAttribute("height")) + 50
          }px`;
          break;
      }
    }
  };

  const videoContainerSize = () => {
    if(videoContainerRef?.current) {
      const ratio = 9/16;
      const videoWidth = videoContainerRef.current.clientWidth;
      const videoHeight = Math.round(videoWidth * ratio);
      setVideoContainerHeight(`${videoHeight}px`);
    }
  }

  useEffect(() => {
    const handleWindowResize = () => {
      setWindowWidth(window.innerWidth);
      resizeIframe(window.innerWidth);
      videoContainerSize();
    };
    resizeIframe(window.innerWidth);
    videoContainerSize();

    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  });
  
  return (
    <>
      <div className={`${Alias}`}>
        <PageTransition delay={ShowHero && "200"}>
           {/*<BreadcrumbsComp Items={Breadcrumbs} />*/}
          <PageContainer
            paddingtop={ShowHero && "0px"}
            className={`${NarrowText ? "narrowText" : ""}`}
          >
            <SplitPageWrapper centerContent={CenterContent}>
              <PageColumn
                centerContent={CenterContent}
                alignContentLeft={AlignContentLeft}
              >
                {!ShowHero && (
                  <H1
                    className={`${UseFontMarydale ? "marydale" : ""}`}
                    margin="0 0 20px 0"
                  >
                    {Heading}
                  </H1>
                )}
                {ShowSocialIcons && <SocialShareBlock share={SocialShare} />}
                <ContentWrapper>
                  {!ShowHero && Preamble && (
                    <Ingress
                      className="ingress"
                      marginSmall="0 0 15px 0"
                      margin="0 0 30px 0"
                      narrowText={NarrowText}
                      dangerouslySetInnerHTML={{
                        __html: Preamble,
                      }}
                    ></Ingress>
                  )}
                  {!ShowHero &&
                    Image &&
                    (VideoLink ? (
                      <VideoContainer ref={videoContainerRef} height={videoContainerHeight} marginBottom={'30px'}>
                        <Video
                          Image={Image}
                          VideoType={VideoType}
                          VideoLink={VideoLink}
                          videoHeight={videoContainerHeight}
                        />
                      </VideoContainer>
                    ) : (
                      <StandardImage src={Image} byline={ImageText} />
                    ))}
                  {Text && (
                    <RTEWrapper
                      className="body_text"
                      narrowText={NarrowText}
                      dangerouslySetInnerHTML={{
                        __html: Text,
                      }}
                    ></RTEWrapper>
                  )}
                </ContentWrapper>

                {LastUpdated && (
                  <Paragraph>
                    {LastUpdatedText} <Bold>{LastUpdated}</Bold>
                  </Paragraph>
                )}
              </PageColumn>
              {hasChildren && !CenterContent && (
                <PageColumn>
                  <SideMenu {...menu} />
                </PageColumn>
              )}
            </SplitPageWrapper>
          </PageContainer>
        </PageTransition>
        {Contacts && (
          <ElementAreaWrapper>
            {Contacts.map((block, key) => (
              <EmployeeListBlock {...block} key={`employee-list-${key}`} />
            ))}
          </ElementAreaWrapper>
        )}
        <ElementAreaWrapper className="transition_list" grey>
          {ElementArea.length > 0 &&
            MapBlocksToComponents(ElementArea, NarrowText, CenterContent, ShowHero)}
        </ElementAreaWrapper>
        {ShowRelatedLinks && RalatedLinks?.length && (
          <ArticleBlock
            SearchHits={RalatedLinks}
            Heading={RelatedTitle ? RelatedTitle : RelatedTitileLink?.Name}
            HeadingUrl={RelatedTitileLink?.Url}
          />
        )}
      </div>
    </>
  );
};

StandardPage.propTypes = {
  Heading: PropTypes.string,
  Text: propTypes.string,
};
const ElementAreaWrapper = styled.div`
  background-color: ${({ theme, grey }) =>
    grey ? theme.colors.lightgrey : "white"};
`;

const VideoContainer = styled.div`
  margin: ${({ margin }) => (margin ? margin : "")};
  height: ${({ height }) => height};
  ${({ marginBottom }) =>
    marginBottom &&
    css`
    margin-bottom: ${marginBottom};  
  `}
  ${media.lessThan(breakpoints.mobile)`
	height: ${({ height }) => (height ? height : "200px")};

button{
    height: 40px;
    width: 40px;
    i{
        font-size: 30px;
    }
}
    h1{
        margin-left: 20px;
        font-size: 16px;
        line-height: 24px;
        
    }
`}
`;

export default StandardPage;
